import { useNavigate } from '@rocketlane/rocket-router';
import { useCallback } from 'react';
import { ROUTE_PATHS } from 'routes/route-paths';

const isModuleFederation =
  typeof process !== 'undefined' && process.env.IS_MODULE_FEDERATION === 'true';

const getAccountDetailRoute = (companyId: number, projectId?: number) => {
  // If projectId is provided (module federation mode), use project routes
  if (projectId != null || isModuleFederation) {
    const id = projectId ?? companyId;

    return `/projects/${id}/email-pages`;
  }

  return `/${ROUTE_PATHS.ACCOUNTS}/${ROUTE_PATHS.ACCOUNT_DETAIL.replace(
    ':accountId',
    companyId.toString() ?? '',
  )}`;
};
const getBaseEmailPageRoute = (
  companyId: number,
  emailId?: number,
  projectId?: number,
) => {
  const baseRoute = getAccountDetailRoute(companyId, projectId);

  // If projectId is provided (module federation mode), use project routes
  if (projectId != null || isModuleFederation) {
    return emailId ? `${baseRoute}/${emailId}` : baseRoute;
  }

  const emailsPath = emailId
    ? ROUTE_PATHS.ACCOUNT_DETAIL_EMAILS.replace(':emailId?', emailId.toString())
    : ROUTE_PATHS.ACCOUNT_DETAIL_EMAILS.replace('/:emailId?', '');

  return `${baseRoute}/${emailsPath}`;
};
const getEmailPageListRoute = (companyId: number, projectId?: number) => {
  return getBaseEmailPageRoute(companyId, undefined, projectId);
};
const getEmailPageRoute = (
  companyId: number,
  emailId: number,
  projectId?: number,
) => {
  return getBaseEmailPageRoute(companyId, emailId, projectId);
};
const getEmailPageEditRoute = (
  companyId: number,
  emailId: number,
  projectId?: number,
) => {
  const baseRoute = getEmailPageRoute(companyId, emailId, projectId);

  // If projectId is provided (module federation mode), use project routes
  if (projectId != null || isModuleFederation) {
    return `${baseRoute}/edit`;
  }

  return `${baseRoute}/${ROUTE_PATHS.ACCOUNT_DETAIL_EMAIL_EDIT}`;
};

export const useEmailPagesRouteNavigations = (projectId?: number) => {
  const navigate = useNavigate();
  const navigateToList = useCallback(
    (companyId: number) => {
      navigate(getEmailPageListRoute(companyId, projectId));
    },
    [navigate, projectId],
  );
  const navigateToEmail = useCallback(
    (companyId: number, emailId: number) => {
      navigate(getEmailPageRoute(companyId, emailId, projectId));
    },
    [navigate, projectId],
  );
  const navigateToEmailEdit = useCallback(
    (companyId: number, emailId: number) => {
      navigate(getEmailPageEditRoute(companyId, emailId, projectId));
    },
    [navigate, projectId],
  );

  return {
    navigateToList,
    navigateToEmail,
    navigateToEmailEdit,
  };
};
